export default {
  cardLabel: {
    id: 'landing_iphone17_card_label',
    defaultMessage: "Don't buy the hype",
  },
  title: {
    id: 'landing_iphone17_title',
    defaultMessage: 'iPhone 17 • New',
  },
  priceStartAt: {
    id: 'landing_iphone17_price_start_at',
    defaultMessage: 'Starting at:',
  },
  price: {
    id: 'landing_iphone17_price',
    defaultMessage: '$#!@',
  },
  strikedPrice: {
    id: 'landing_iphone17_price_striked',
    defaultMessage: 'Worth the update',
  },
}
